import layout from '@/layout'
const meta = { auth: true }

export default {
  path: '/systemUI',
  component: layout,
  children: ((pre) => [
    {
      path: 'merchantParamSet',
      name: `${pre}parameter`,
      meta: {
        ...meta,
        cache: true,
        title: '系统参数设置',
        head: true,
        funcID: 'B0901',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/merchantParamSet')
    },
    {
      path: 'merchantOrganizationSet',
      name: `${pre}organization`,
      meta: {
        ...meta,
        cache: true,
        title: '组织架构维护',
        head: true,
        funcID: 'B0902',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/systemUI/merchantOrganizationSet')
    },
    {
      path: 'merchantDepartmentSet',
      name: `${pre}business`,
      meta: {
        ...meta,
        cache: true,
        title: '业务部门维护',
        head: true,
        funcID: 'B0903',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/systemUI/merchantDepartmentSet')
    },
    {
      path: 'merchantRoleSet',
      name: `${pre}role`,
      meta: {
        ...meta,
        cache: true,
        title: '角色权限维护',
        head: true,
        funcID: 'B0904',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/merchantRoleSet')
    },
    {
      path: 'merchantRoleSet/:pageType/:roleID?',
      name: `${pre}role-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '角色权限维护',
        head: false,
        funcID: 'B0904',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/systemUI/merchantRoleSet/detail')
    },
    {
      path: 'merchantUserSet',
      name: `${pre}sysuser`,
      meta: {
        ...meta,
        cache: true,
        title: '系统用户管理',
        head: true,
        funcID: 'B0905',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/merchantUserSet')
    },
    {
      path: 'merchantUserSet/:pageType/:userCode?',
      name: `${pre}sysuser-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '系统用户管理',
        head: false,
        funcID: 'B0905',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/systemUI/merchantUserSet/detail')
    },
    {
      path: 'merchantOperationLog',
      name: `${pre}operationLog`,
      meta: {
        ...meta,
        cache: true,
        title: '系统操作日志',
        head: true,
        funcID: 'B0906',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/merchantOperationLog')
    },
    {
      path: 'merchantSerialNoRuleSet',
      name: `${pre}serialNoRule`,
      meta: {
        ...meta,
        cache: true,
        title: '编码规则设置',
        head: true,
        funcID: 'B0907',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/systemUI/merchantSerialNoRuleSet')
    },
    {
      path: 'systemDictionary',
      name: `${pre}dictionary`,
      meta: {
        ...meta,
        cache: true,
        title: '系统字典维护',
        head: true,
        funcID: 'B0908',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/systemDictionary')
    },
    {
      path: 'thdapiOaLog',
      name: `${pre}thdapiOaLog`,
      meta: {
        ...meta,
        cache: true,
        title: 'OA接口日志',
        head: true,
        funcID: 'B0909',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/thdapiOaLog')
    },
    {
      path: 'sysVersion',
      name: `${pre}sysVersion`,
      meta: {
        ...meta,
        cache: true,
        title: '版本发布记录',
        head: true,
        funcID: 'B0910',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/sysVersion')
    },
    {
      path: 'sysQuartzTask',
      name: `${pre}sysQuartzTask`,
      meta: {
        ...meta,
        cache: true,
        title: '自动任务维护',
        head: true,
        funcID: 'B0911',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/sysQuartzTask')
    },
    {
      path: 'sysQuartzTask/:pageType/:code?',
      name: `${pre}sysQuartzTask-detail`, 
      meta: {
        ...meta,
        cache: true,
        title: '自动任务维护',
        head: false,
        funcID: 'B0911',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/systemUI/sysQuartzTask/detail')
    },
    {
      path: 'merchantFunctionFormLanguage',
      name: `${pre}merchantFunctionFormLanguage`,
      meta: {
        ...meta,
        cache: true,
        title: '多语言维护',
        head: true,
        funcID: 'B0912',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/merchantFunctionFormLanguage')
    },
    {
      path: 'inoutTemplate',
      name: `${pre}inoutTemplate`,
      meta: {
        ...meta,
        cache: true,
        title: '系统模版维护',
        head: true,
        funcID: 'B0913',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/inoutTemplate')
    },
    {
      path: 'sysCustomerExport',
      name: `${pre}sysCustomerExport`,
      meta: {
        ...meta,
        cache: true,
        title: '客户模板配置维护',
        head: true,
        funcID: 'B0914',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/sysCustomerExport')
    },
    {
      path: 'sysCustomerExport/:pageType/:customerExportTemplateCode?',
      name: `${pre}sysCustomerExport-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '客户模板配置维护',
        head: false,
        funcID: 'B0914',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/systemUI/sysCustomerExport/detail')
    },
    {
      path: 'thdapiOaResultApiSet',
      name: `${pre}thdapiOaResultApiSet`,
      meta: {
        ...meta,
        cache: true,
        title: 'OA结果处理接口配置',
        head: true,
        funcID: 'B0915',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/thdapiOaResultApiSet')
    },
    {
      path: 'thdapiOaResultApiSet/:pageType/:functionCode?',
      name: `${pre}thdapiOaResultApiSet-detail`,
      meta: {
        ...meta,
        cache: true,
        title: 'OA结果处理接口配置',
        head: false,
        funcID: 'B0915',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/systemUI/thdapiOaResultApiSet/detail')
    },
    {
      path: 'menuMaintenance',
      name: `${pre}menuMaintenance`,
      meta: {
        ...meta,
        cache: true,
        title: '菜单维护',
        head: true,
        funcID: 'B0916',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/systemUI/menuMaintenance'),
    },
    {
      path: 'messageTemplate',
      name: `${pre}messageTemplate`,
      meta: {
        ...meta,
        cache: true,
        title: '消息模板配置',
        head: true,
        funcID: 'B0917',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/messageTemplate')
    },
    {
      path: 'messageTemplate/:pageType/:templateCode?',
      name: `${pre}messageTemplate-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '消息模板配置',
        head: true,
        funcID: 'B0917',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/messageTemplate/detail')
    },
    {
      path: 'messageTask',
      name: `${pre}messageTask`,
      meta: {
        ...meta,
        cache: true,
        title: '消息任务日志',
        head: true,
        funcID: 'B0918',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/systemUI/messageTask')
    }
  ])('system-')
}
